import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';

import { ErrorEntityInterface } from 'app/core/error-handler/models/index';
import { ErrorStateInterface } from 'app/core/error-handler/state/models/index';

import { ErrorActions, ErrorActionType } from './actions/index';

export const errorAdapter: EntityAdapter<ErrorEntityInterface> = createEntityAdapter<ErrorEntityInterface>({
  selectId: ({ id }: ErrorEntityInterface): string => id,
  sortComparer: false,
});

export const initialErrorState: ErrorStateInterface = errorAdapter.getInitialState({});

export function errorReducer(
  state: ErrorStateInterface = initialErrorState,
  action: ErrorActions): ErrorStateInterface {
  switch (action.type) {
    case ErrorActionType.ErrorRaised:
    case ErrorActionType.ErrorHandled:
    case ErrorActionType.UnhandledError:
      return errorAdapter.upsertOne(action.payload, state);

    case ErrorActionType.ErrorRaisedRemoved:
      return {
        ...state,
        ids: [],
        entities: {},
      };

    default:
      return state;
  }
}
